var selectedColor = '';
var selectedGrade = '';
var selectedFabric = '';
var EleHeight = 0;
var itemCount = 0;

class americanSwatch {

  constructor() {

    const radioButtonsColor = document.querySelectorAll('[data_color]');
    const radioButtonsGrade = document.querySelectorAll('[data_grade]');
    const radioButtonsFabric = document.querySelectorAll('[data_fabric]');
    const gridItems = document.querySelectorAll('[data-swatch-item]');

    itemCount = gridItems.length;

    const swatchItems = document.querySelectorAll('[data-swatch-item]');

    if (
      swatchItems.length > 1 &&
      swatchItems[1].querySelector('.swatch-more-wrapper')
    ) {

      EleHeight = swatchItems[1]
        .querySelector('.swatch-more-wrapper')
        .offsetHeight;

      const firstDetails =
        swatchItems[0].querySelector('[swatch_detials]');

      if (firstDetails) {
        firstDetails.style.height = `${EleHeight}px`;
      }
    }

    radioButtonsColor.forEach(ele => {
      ele.addEventListener('change', (event) => {
        this._colorChange(event);
      });
    });

    radioButtonsFabric.forEach(ele => {
      ele.addEventListener('change', (event) => {
        this._fabricChange(event);
      });
    });

    radioButtonsGrade.forEach(ele => {
      ele.addEventListener('change', (event) => {
        this._gradeChange(event);
      });
    });

    gridItems.forEach(ele => {
      ele.addEventListener('click', (event) => {
        this._showItemDetials(event);
      });
    });

  }

  _colorChange(event) {

    if (event.target.checked) {
      selectedColor = event.target.value || '';
      this._loadSwatchGrid();
    }

  }

  _fabricChange(event) {

    if (event.target.checked) {
      selectedFabric = event.target.value || '';
      this._loadSwatchGrid();
    }

  }

  _gradeChange(event) {

    if (event.target.checked) {
      selectedGrade = event.target.value || '';
      this._loadSwatchGrid();
    }

  }

  _loadSwatchGrid() {

    const gridElements = document.querySelectorAll('[data-swatch-details]');
    let visibleCount = 0;

    gridElements.forEach(ele => {

      let itemFound = false;

      try {

        const scriptContent = ele.textContent.trim();

        if (!scriptContent) {

          ele.closest('[data-swatch-item]')?.classList.add('d-none');
          return;

        }

        const data = JSON.parse(scriptContent);

        const selectedColorValue = selectedColor || '';
        const selectedGradeValue = selectedGrade || '';
        const selectedFabricValue = selectedFabric
          ? selectedFabric.toLowerCase()
          : '';

        data.forEach(item => {

          const itemColor = item.color || '';

          const itemFabric = item.fabric_type
            ? item.fabric_type.toLowerCase()
            : '';

          const itemGrade = item.grade || '';

          let matches = true;

          // Color filter
          if (
            selectedColorValue &&
            !itemColor.includes(selectedColorValue)
          ) {
            matches = false;
          }

          // Fabric filter
          if (
            selectedFabricValue &&
            !itemFabric.includes(selectedFabricValue)
          ) {
            matches = false;
          }

          // Grade filter
          if (
            selectedGradeValue &&
            itemGrade != selectedGradeValue
          ) {
            matches = false;
          }

          if (matches) {
            itemFound = true;
          }

        });

        const swatchItem = ele.closest('[data-swatch-item]');

        if (!swatchItem) return;

        if (itemFound) {

          swatchItem.classList.remove('d-none');
          visibleCount++;

        } else {

          swatchItem.classList.add('d-none');

        }

      } catch (error) {

        console.error('Swatch JSON Error:', error);

        ele.closest('[data-swatch-item]')?.classList.add('d-none');

      }

    });

    const emptySearch = document.querySelector('[empty-search]');

    if (emptySearch) {

      if (visibleCount === 0) {
        emptySearch.classList.remove('d-none');
      } else {
        emptySearch.classList.add('d-none');
      }

    }

  }

  _showItemDetials(event) {

    const currentEle = event.currentTarget;

    document.querySelectorAll('[data-swatch-item]').forEach(ele => {

      ele.classList.remove('active');

      const imageWrapper = ele.querySelector('.image_wrapper');
      const detailsWrapper = ele.querySelector('[swatch_detials]');

      if (imageWrapper) {
        imageWrapper.classList.remove('active');
      }

      if (detailsWrapper) {
        detailsWrapper.removeAttribute('style');
      }

    });

    currentEle.classList.add('active');

    const currentImage =
      currentEle.querySelector('.image_wrapper');

    if (currentImage) {
      currentImage.classList.add('active');
    }

    const moreWrapper =
      currentEle.querySelector('.swatch-more-wrapper');

    const detailsWrapper =
      currentEle.querySelector('[swatch_detials]');

    if (
      moreWrapper &&
      detailsWrapper
    ) {

      const height_el = moreWrapper.offsetHeight;

      detailsWrapper.style.height = `${height_el}px`;

    }

  }

}

document.addEventListener('DOMContentLoaded', () => {
  new americanSwatch();
});